<script setup>

import { ref, watch, nextTick } from 'vue';
import Dialog from 'primevue/dialog';
import {
	getBlocEntetesTableau } from '@/scripts/global.js';

const { elements } = defineProps({
    elements: Array
});

const visible = defineModel('visible', {
    type: Boolean
});

const emit = defineEmits(['modifDecalageElementRapport', 'modifDecalageBlocTableau']);

const decalageSaisi = ref(getDecalageParDefaut());
const composantSaisieDecalage = ref(null);

watch(() => elements, (elts) => {
    decalageSaisi.value = getDecalageParDefaut();
});

watch(() => visible.value, (visible) => {
    if (visible) {
        nextTick(() => {
            composantSaisieDecalage.value.focus();
        });
    }
});

function getDecalageParDefaut() {
    if (elements?.length > 0) {
        let premierElement = elements[0];
        if (premierElement.elementParent?.type == 'TABLEAU') {
            return getBlocEntetesTableau(premierElement, premierElement.elementParent).decalage;
        } else {
            return 0;
        }
    } else {

    }
}

function valider() {
    let premierElement = elements[0];
    if (premierElement.elementParent?.type === 'TABLEAU') {
        let tableau = premierElement.elementParent;
        emit('modifDecalageBlocTableau', tableau, getBlocEntetesTableau(premierElement, tableau), decalageSaisi.value);
    } else {
        emit('modifDecalageElementRapport', premierElement, decalageSaisi.value);
    }
}

</script>

<template>
    <Dialog 
    v-model:visible="visible" 
    modal 
    header="Edition du décalage d'un bloc de tableau">
        <label class="intitule">Décalage :</label>
        <input 
            type="number"
            ref="composantSaisieDecalage" 
            v-model.number="decalageSaisi"
            @keyup.enter="valider()">
        <template #footer>
            <button 
                class="bouton fas fa-check" 
                :disabled="false"
                @click="valider()"/>
        </template>
    </Dialog>
</template>

<style scoped>

</style>